enum IdProofTypeEnum {
    DriverLicence = 'DRIVER_LICENCE',
    Passport = 'PASSPORT',
}

export default IdProofTypeEnum;
